import styled from "styled-components";

export const FooterContainer = styled.footer`
    backgroung-color: #fff;
`;

export const FooterWrap = styled.div`
    padding: 20px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-contern: center;
    max-width: 1100px;
    margin: 0 auto;
`;

export const FooterItem = styled.h5`
    font-size: 18px;
    line-height: 27px;
    font-weight: normal;
    margin: 2px 0;
    text-align: center;
`;
